import prizemlje1 from '../assets/img/aprtmani_novo/Prizemlje1-1.jpg';
import prizemlje1i2 from '../assets/img/aprtmani_novo/Prizemlje1-2.jpg';

const prizemlje = [
{
    id: 1,
    title: 'Prizemlje',
    text: 'Poseduje integralni prostor dnevnog boravka i noćne zone koji su delimično odvojeni zidanim delom. Njihove pozicije u zgradi su od prizemlja 1, prizemlja 2, potkrivlja 1.',
    size: '20.7',
    image: prizemlje1
},
{
    id: 2,
    title: 'Prizemlje 1-2',
    text: 'Poseduje jasno definisane dnevne i noćne zone. Njihove pozije u zgradi su na nivoima prizemlja i prizemlja 2 kao i potrkovlja 1. Svaki od njih poseduje terasu.',
    size: '20.7',
    image: prizemlje1i2
},

]

export default prizemlje;